import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useStore from "../../features/store";
import Loading from "../../components/common/loading";
import usersIcon from "../../assets/icons/users.svg";
import { formateDateToJalali, genderConverter } from "../../utils/Functions";
import { Fade } from "react-awesome-reveal";

const TempUsers = () => {
  const navigate = useNavigate();
  //@ts-ignore
  const { isLoadingTempUsers, tempUsers, fetchTempUsers } = useStore();

  const clickUserHandler = (first_name: any, last_name: any) => {
    const namesSet = new Set<string>();

    if (first_name || first_name) {
      namesSet.add(`${first_name} ${last_name}`);
    }

    //@ts-ignore
    navigate(`/records?users=${[...namesSet].join(",").replace(/ /g, "_")}`);
  };

  useEffect(() => {
    if (!tempUsers) fetchTempUsers();
  }, [tempUsers]);

  return (
    <div className="flex-1 my-10">
      <div className="flex flex-col items-start justify-between">
        <div className="flex items-center">
          <img src={usersIcon} width={28} alt="کاربران زیرمجموعه" />
          <h1 className="font-[800] mr-3 mt-2 font-rokh text-lg">
            کاربران زیرمجموعه
          </h1>
        </div>
      </div>
      <Fade triggerOnce className="mt-10">
        {isLoadingTempUsers ? (
          <Loading />
        ) : (
          <div className="w-full">
            {tempUsers?.results.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                {tempUsers?.results?.map((user: any) => (
                  <div
                    onClick={() =>
                      clickUserHandler(user.first_name, user.last_name)
                    }
                    key={user.id}
                    className="bg-pr_purple p-10 rounded-xl cursor-pointer"
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <h2 className="font-rokh font-[900] text-xl">
                          {user.first_name} {user.last_name}
                        </h2>
                        <h3 className="font-rokh font-[500] text-sm">
                          {user.name ?? ""}
                        </h3>
                      </div>
                      <div className="flex items-center justify-start font-rokh font-[700]">
                        {user.test_count} تست
                      </div>
                    </div>

                    <div className="mt-10 flex items-center justify-start">
                      <h6 className="flex-1 text-sm">تاریخ تولد:</h6>
                      <h5 className="font-rokh font-[700] pt-2">
                        {formateDateToJalali(user.birth_day)}
                      </h5>
                    </div>

                    <div className="mt-1 flex items-center justify-start">
                      <h6 className="flex-1 text-sm">جنسیت:</h6>
                      <h5 className="font-rokh font-[700] pt-2">
                        {genderConverter(user.gender)}
                      </h5>
                    </div>

                    <div className="mt-1 flex items-center justify-start">
                      <h6 className="flex-1 text-sm">تاریخ آخرین آزمایش:</h6>
                      <h5 className="font-rokh font-[700] pt-2">
                        {formateDateToJalali(user.latest_test_date)}
                        <span className="font-rokh font-[500] pt-2 text-sm">
                          {" "}
                          ({user.time_since_latest_test} روز گذشته است)
                        </span>
                      </h5>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-full mx-auto">
                <h1 className="text-center font-rokh font-[900] text-lg mt-16">
                  آزمایش آشناهات رو هم توی بادی‌بان تحلیل کن.
                </h1>
                <Link
                  to="/test-registration"
                  className="btn bg-pr_primary hover:bg-pr_blue_dark text-white w-full lg:w-1/4 mt-4"
                >
                  تحلیل آزمایش
                </Link>
              </div>
            )}
          </div>
        )}
      </Fade>
    </div>
  );
};

export default TempUsers;
